import { render, staticRenderFns } from "./undertake.vue?vue&type=template&id=4f63984c&scoped=true"
import script from "./undertake.vue?vue&type=script&lang=js"
export * from "./undertake.vue?vue&type=script&lang=js"
import style0 from "./undertake.vue?vue&type=style&index=0&id=4f63984c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63984c",
  null
  
)

export default component.exports